<template>
  <v-col
    v-bind="{ ...containerProps, ...containerOptions }"
  >
    <v-dialog
      ref="dialog"
      v-model="dialog"
      :return-value.sync="modelValue"
      persistent
      width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          ref="dateField"
          v-bind="$attrs"
          :color="colors.base"
          :hide-details="!$attrs.hint"
          :value="formattedValue"
          type="text"
          readonly
          v-on="on"
        >
          <template #label>
            <b :class="colors.text">{{ chapter }}</b>
            {{ $attrs.label }}
          </template>
        </v-text-field>
      </template>
      <v-date-picker
        v-model="modelValue"
        scrollable
        :color="colors.base"
        locale="fi"
        first-day-of-week="1"
        actions
        @change="setDate()"
      />
    </v-dialog>

    <v-btn
      :color="colors.base"
      :disabled="modelValue === ''"
      class="text-body-2 mt-2"
      small
      text
      @click="modelValue = ''"
    >
      Poista valinta
    </v-btn>
  </v-col>
</template>

<script>
import { EventBus } from '@/utils';

export default {
  name: 'HelmiDatePicker',

  inheritAttrs: false,

  props: {
    chapter: {
      type: String,
      default: '',
    },

    colors: {
      type: Object,
      default: () => ({
        base: 'primary',
        text: 'primary--text',
      }),
    },

    containerProps: {
      type: Object,
      default: () => ({}),
    },

    containerOptions: {
      type: Object,
      default: () => ({}),
    },

    propertyValue: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    formattedValue: '',
    dialog: false,
    modelValue: '',
    defaultValue: '',
  }),

  computed: {
    label() {
      return `${this.chapter} ${this.$attrs.label}`;
    },
  },

  watch: {
    // Handles internal model changes.
    modelValue(newVal) {
      this.$emit('input', newVal);
      this.$emit('evaluate', newVal, this.$attrs.id);
      this.formattedValue = newVal ? this.$options.filters.date(newVal) : '';
    },

    // Handles external model changes.
    '$attrs.value': {
      handler(val) {
        this.modelValue = val;
      },
      immediate: true,
    },
  },

  mounted() {
    EventBus.$on('FORM_RESET', this.resetValue);
  },

  methods: {
    openDialog() {
      this.dialog = true;
    },

    resetValue() {
      this.modelValue = this.propertyValue || this.defaultValue;
    },

    async setDate() {
      await this.$nextTick();
      console.warn('wtf');
      this.$refs.dialog.save(this.modelValue);
      this.$refs.dateField.$emit('change');
      this.dialog = false;
    },
  },
};
</script>
